/**
 * FeedbackCategoryRecipientService
 * Service for FeedbackCategoryRecipient entity operations
 * Route: api/feedbackcategoryrecipient
 */
import { CrudService } from '../base/CrudService';
/**
 * FeedbackCategoryRecipientService
 * Handles category recipient CRUD operations
 */
export class FeedbackCategoryRecipientService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FeedbackCategoryRecipientService.DEFAULT_SERVICE_PATH,
            basePath: FeedbackCategoryRecipientService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
FeedbackCategoryRecipientService.DEFAULT_SERVICE_PATH = 'feedback';
FeedbackCategoryRecipientService.BASE_PATH = 'api/feedbackcategoryrecipient';
//# sourceMappingURL=FeedbackCategoryRecipientService.js.map